import React from "react";
import PropTypes from "prop-types";
import { StyledLink } from "./_.styled";

const FieldWrapper = ({ href, onClick, children }) =>
  href ? (
    <StyledLink href={href} onClick={onClick}>{children}</StyledLink>
  ) : (
    <div>{children}</div>
  );

FieldWrapper.propTypes = {
  href: PropTypes.string,
  onClick: PropTypes.func,
};

FieldWrapper.displayName = "FieldWrapper";
export default FieldWrapper;
